import { Observable, of } from 'rxjs';
import { Inject, Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CompanyDetailsFromVatService } from '~app/modules/authorization/services/company-details-from-vat.service';
import { APP_USER_TAX_ID_CHECK_ROUTE, APP_USER_VAT_ID_CHECK_ROUTE, CountryCode } from '~shared/constants';
import { catchError, map } from 'rxjs/operators';
import { CompanyDetailsFromIdService } from '~app/modules/authorization/services/company-details-from-id.service';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { getCountryDomainCode } from '~server/utils/country-detection.util';

@Injectable({
  providedIn: 'root',
})
export class Tier2SignupGuard implements CanActivate {
  constructor(
    protected companyDetailsFromVatService: CompanyDetailsFromVatService,
    protected companyDetailsFromIdService: CompanyDetailsFromIdService,
    private router: Router,
    @Optional() @Inject(REQUEST) private webAppBuyerRequest: any) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const market = getCountryDomainCode(this.webAppBuyerRequest);
    const isPortugueseMarket = market === CountryCode.Portugal;
    const isItalianMarket = market === CountryCode.Italy;
    const isFrenchMarket = market === CountryCode.France;
    const isDutchMarket = market === CountryCode.Netherlands;
    const isVATNumberFlow = isPortugueseMarket || isItalianMarket;
    const isTaxWithBranchFlow = isDutchMarket || isFrenchMarket;

    if (isVATNumberFlow) {
      return this.companyDetailsFromVatService.companyDetailsForTierTwo.pipe(
        map((companyDetails) => {
          if (!companyDetails) {
            return this.router.createUrlTree([APP_USER_VAT_ID_CHECK_ROUTE], {
              queryParams: { verifiedVAT: false },
            });
          } else {
            return true;
          }
        }),
        catchError((err) => {
          return of(true);
        })
      );
    }

    return this.companyDetailsFromIdService.companyDetailsForTierTwoNLandFR.pipe(
      map((companyDetails) => {
        if (!companyDetails && isTaxWithBranchFlow) {
          return this.router.createUrlTree([APP_USER_TAX_ID_CHECK_ROUTE], {
            queryParams: { verifiedTaxId: false },
          });
        } else {
          return true;
        }
      }),
      catchError((err) => {
        return of(true);
      })
    );
  }
}
